import React from "react";
import { Input } from "antd";
import { ColumnType } from "antd/lib/table";
import classnames from "classnames";
import { trim } from "lodash";
import { EMPTY } from "constants/common";
import { AiccUiElementTranslationRow } from "types/model/aiccLearningAssets";
import { UI_ELEMENT_TRANSLATION_REQUIRED } from "./configs";
import styles from "../LearningAssets.module.scss";

interface ColumnHandlers {
  isEditing: boolean;
  showErrors: boolean;
  onTranslationChange: (element: string, translation: string) => void;
}

const getColumns = ({
  isEditing,
  showErrors,
  onTranslationChange,
}: ColumnHandlers): ColumnType<AiccUiElementTranslationRow>[] => [
  {
    title: "UI Element",
    dataIndex: "id",
    key: "id",
    width: 320,
  },
  {
    title: "Translation",
    dataIndex: "translation",
    key: "translation",
    width: 360,
    render: (translation: string | undefined, row) => {
      const isMissing = showErrors && !trim(translation);

      return (
        <div className={styles.stackedCell}>
          {isEditing ? (
            <Input
              className={classnames({ [styles.inputError]: isMissing })}
              value={translation}
              placeholder="Translation"
              onChange={(event) => onTranslationChange(row.id, event.target.value)}
            />
          ) : (
            <div>{translation || EMPTY}</div>
          )}
          {isMissing && <div className={styles.fieldErrorText}>{UI_ELEMENT_TRANSLATION_REQUIRED}</div>}
        </div>
      );
    },
  },
];

export default getColumns;
